exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".change-lang-confirmation__title{font-size:24px;padding:24px 0;padding-inline-start:40px}.change-lang-confirmation__note{padding-inline-start:40px}.change-lang-confirmation__footer{display:flex;justify-content:center;gap:24px;margin-top:24px}.change-lang-confirmation__footer .btn-close,.change-lang-confirmation__footer .btn-ok{padding:6px 18px;border-radius:18px}.change-lang-confirmation__footer .btn-ok{background:#53b8d4;color:#fff}.change-lang-confirmation__footer .btn-close{border:1px solid #53b8d4;color:#53b8d4}", ""]);

// exports
